module.exports = __webpack_public_path__ + "static/media/22a.b73bffeb.jpg";